import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import useUpdateEffect from '../../../hooks/useUpdateEffect';

import {
  featureFlagsSelector,
  licenseTypeAdditionalFieldsByTabsSelector,
  validationConfigSelector,
} from '../store/selectors';
import { getValidationConfig } from '../store/actions';
import { getLicenseSchema } from '../schemas';

const defaultSchema = getLicenseSchema();

const useValidationSchema = () => {
  const dispatch = useDispatch();
  const [schema, setSchema] = useState(defaultSchema);
  const additionalFields = useSelector(licenseTypeAdditionalFieldsByTabsSelector);
  const validationConfig = useSelector(validationConfigSelector);
  const featureFlags = useSelector(featureFlagsSelector);

  useEffect(() => {
    !Object.keys(validationConfig).length && dispatch(getValidationConfig());
  }, [dispatch, validationConfig]);

  useUpdateEffect(() => {
    if (Object.keys(additionalFields)?.length) {
      setSchema(getLicenseSchema(additionalFields, validationConfig, featureFlags));
    } else if (Object.keys(validationConfig).length) {
      setSchema(getLicenseSchema({}, validationConfig, featureFlags));
    } else {
      setSchema(defaultSchema);
    }
  }, [additionalFields, validationConfig, featureFlags]);

  return schema;
};

export default useValidationSchema;
